<template>
  <el-dialog
    title="批量修改"
    :visible="visible"
    width="870px"
    center
    custom-class="batch-upload-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-tabs v-model="activeName">
        <el-tab-pane label="统一修改" name="combine">
          <select-input
            v-if="mode === TASK_TYPE_ENUM.MATCH"
            ref="textInput"
            :select-type-map="searchTypeMap"
            :form="form"
            :default-search-type.sync="searchType"
            input-class="text-input"
            select-class="type-select"
            class="select-input"
            type="textarea"
            :rows="5"
          ></select-input>
          <el-form-item v-else label="单据ID" prop="ids">
            <multiple-input
              v-model="form.ids"
              type="textarea"
              :rows="5"
              formatter="number"
              :placeholder="ph"
            ></multiple-input>
          </el-form-item>
          <el-form-item v-if="searchType === 'tmeIdList'" label="TME ID 类型" prop="audioType">
            <el-select v-model="form.audioType">
              <el-option v-for="(name, id) in mediaTypeMap" :key="+id" :label="name" :value="+id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批量修改状态">
            <el-select v-model="form.status" class="form-field" @change="handleStatusChange">
              <el-option v-for="(name, id) in statusMap" :key="+id" :label="name" :value="+id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="mode === TASK_TYPE_ENUM.MATCH" label="确认截止时间">
            <el-date-picker
              v-model="form.expiresTime"
              type="datetime"
              class="form-field"
              placeholder="确认截止时间"
              :picker-options="pickOptions"
              format="yyyy-MM-dd"
              default-time="23:59:59"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item v-if="mode === TASK_TYPE_ENUM.MATCH && bussType === LEVEL_ONE_APPEAL.TORT.code" label="重复版权方ID">
            <el-input-number v-model="form.historyCompany" :controls="false" class="form-field" placeholder="请输入版权公司ID"></el-input-number>
          </el-form-item>
          <!-- 编辑时，状态调整为坚持权利时上传权利文件 -->
          <el-form-item v-if="showUploadRight" label="权利文件">
            <div class="file-uploader">
              <verify-uploader
                action="/action/upload?type=license"
                drag
                :on-preview="handlePreview"
                :on-remove="handleRightFileRemove"
                :on-error="handleRightFileError"
                :on-success="handleRightFileSuccess"
                :before-upload="handleRightFileBeforeUpload"
                :file-list="rightFileList"
                :accept="'.' + rightFileExtType.join(',.')"
              >
                <div slot="trigger" class="upload-trigger">
                  <svg-icon icon-class="upload" class="upload-icon"></svg-icon>
                  <p>点击或将文件拖拽上传权利文件</p>
                  <span>支持格式：{{ rightFileExtType.join(',') }}</span>
                </div>
              </verify-uploader>
            </div>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="批量覆盖" name="batch">
          <el-form-item label="批量修改更多信息">
            <el-button type="primary" size="small" @click="genTemplate">下载模板</el-button>
            <div class="file-uploader">
              <verify-uploader
                action="/action/upload?type=excel"
                drag
                :on-preview="handlePreview"
                :on-remove="handleFileRemove"
                :on-error="handleFileError"
                :on-success="handleFileSuccess"
                :before-upload="handleFileBeforeUpload"
                :file-list="fileList"
                :accept="'.' + fileExtType.join(',.')"
              >
                <div slot="trigger" class="upload-trigger">
                  <svg-icon icon-class="upload" class="upload-icon"></svg-icon>
                  <p>点击或将文件拖拽上传表格</p>
                  <span>支持格式：{{ fileExtType.join(',') }}</span>
                </div>
              </verify-uploader>
            </div>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <div slot="footer" style="margin-top:30px">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">确认提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MultipleInput from '@/components/MultipleInput'
import SelectInput from '@/components/SelectInput/index'
import { VerifyUploader } from '@/components'

import batchUpload from './mixin/batchUpload'

import {
  MATCH_STATUS,
  TASK_TYPE_ENUM,
  levelOneAppealMap,
  appealTrackStatusMap,
  matchStatusMap,
  pickOptions,
  mediaTypeMap,
} from '../const'

const defaultForm = () => ({
  ids: [],
  tmeIdList: [],
  audioType: undefined,
  status: 0,
  expiresTime: void (0),
  historyCompany: undefined
})

const searchTypeMap = {
  tmeIdList: {
    label: 'TmeID',
    placeholder: '请输入TmeID',
    formatter: 'number'
  },
  ids: {
    label: '单据ID',
    placeholder: '请输入单据ID',
    formatter: 'number'
  },
}

export default {
  name: 'BatchEditDialog',
  components: {
    MultipleInput,
    SelectInput,
    VerifyUploader
  },
  mixins: [batchUpload],
  data() {
    return {
      pickOptions,
      searchTypeMap,
      MATCH_STATUS,
      mediaTypeMap,

      form: defaultForm(),
      rules: {
        // ids: [{ required: true, message: '请输入ID', trigger: 'blur' }],
        audioType: [{ required: true, message: '请选择TME ID 类型', trigger: 'blur' }],
      },
      searchType: 'ids',
      activeName: 'combine',
      isEdit: true // batchUpload mixin 里用到了，wtf，以后再改
    }
  },
  computed: {
    statusMap() {
      return this.mode === TASK_TYPE_ENUM.SONGLIST ? appealTrackStatusMap : matchStatusMap
    },
    ph() {
      return this.mode === TASK_TYPE_ENUM.SONGLIST
        ? `请输入需要批量修改的${levelOneAppealMap[this.bussType]}歌单ID`
        : '请输入需要变更状态的匹配结果ID'
    },
    showUploadRight() {
      return this.mode === TASK_TYPE_ENUM.MATCH && this.form.status === MATCH_STATUS.REPEAT_RIGHT.code
    }
  },
  methods: {
    close() {
      this.handleClose()
    },
    handleClose() {
      this.form = defaultForm()
      this.fileList = []
      this.rightFileList = []
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    handleStatusChange() {
      if (!this.showUploadRight) {
        this.rightFileList = []
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
      } catch (error) {
        return
      }

      // ID 和 文件必须有一个
      if (!this.form.ids?.length && !this.form.tmeIdList?.length && !this.fileList?.length) {
        this.$message.warning('请输入ID或传入文件进行批量修改！')
        return
      }

      // 坚持权利必须上传权利文件
      if (this.showUploadRight && !this.rightFileList?.length) {
        this.$message.warning('坚持权利时必须上传权利文件！')
        return
      }

      // 如果选择上传单据ID，清空audioType
      if (this.searchType === 'ids') {
        this.form.audioType = undefined
      }

      this.$emit('submit', { ...this.form }, this.fileList, this.rightFileList)
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .batch-upload-dialog {

  .el-dialog__header {
    border-bottom: 0;
  }

  .el-dialog__footer {
    border-top: 0;
  }

  .el-timeline-item__tail {
    border-left-color: #4071ff;
  }

  .el-upload-list {
    text-align: left;
  }

  .el-upload.el-upload--text {
    width: 100%;
    background: #FAFBFB;
    border: 1px dashed #4071FF;
    border-radius: 4px;
    padding: 10px;
  }
}

.form-field {
  width: 250px;
}

.file-uploader {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  margin-top: 16px;

  section {
    width: 340px;
    border: 1px solid #D9DEE1;
    border-radius: 4px;
    padding: 10px;
    text-align: center;

    ::v-deep .el-upload-dragger{
      padding-top: 10px;
      width: 296px;
    }

    p {
      font-size: 16px;
      color: #002432;
    }

    span {
      display: inline-block;
      margin-top: 8px;
      color: #8C9CA3;
    }
  }
}
</style>
